import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 16px;

  border: 2px solid #d1d1d1;

  padding: 16px;

  border-radius: 4px;
`;

export const ItemsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const MinhaRenegociacaoHeader = styled.div`
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  padding: 8px;
  padding-left: 16px;
`;

export const MsgErroRenegociacao = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 20px;
  color: #4d4d4d;
  font-size: 15.9px;
  svg {
    border: 5px solid #ba122b;
    padding: 0;
    border-radius: 40px;
    font-size: 48px;
    width: 50px;
    box-sizing: border-box;
    height: 50px;
    min-width: 50px;
  }
`;
